module.exports = __webpack_public_path__ + "media/images/app/benefits/trend-7d6dfadf9de685be38cd626297552e0f.webp";